<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="regulador.procedimentosCirurgicos"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
// Mixins.
import { formats } from '@/mixins'

export default {
    data() {

        return {
            fields: [
                {
                    key: 'codigo',
                    label: 'Código',
                    formatter: codigo => codigo ? this.formatProcedimento(codigo) : '-',
                    sortable: true,
                    class: 'col-min',
                },
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'grupoNome', label: 'Grupo', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
        }
    },
    methods: {
        destroy(procedimentoCirurgico) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o procedimentos cirúrgicos?',
                async () => this.regulador.procedimentosCirurgicos
                    .splice(this.regulador.procedimentosCirurgicos.indexOf(procedimentoCirurgico), 1)
            )
        }
    },
    mixins: [formats],
    props: {
        regulador: { type: Object, required: true },
    }
}
</script>